import { useAuth } from './useAuth';

/**
 * Simple hook to get the current user's ID
 * @returns {string | null} The authenticated user's ID or null if not authenticated
 */
export const useUserId = () => {
  const { user } = useAuth();
  const userId = user?.id || null;
  
  return userId;
};